import { render, staticRenderFns } from "./LogHistory.vue?vue&type=template&id=33664972&"
import script from "./LogHistory.vue?vue&type=script&lang=js&"
export * from "./LogHistory.vue?vue&type=script&lang=js&"
import style0 from "./LogHistory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports